import * as React from 'react';
import { Select, Typography } from 'antd';
import './SelectorItem.scss';
import { SelectProps } from 'antd/lib/select';

type UiMode = 'horizontal' | 'vertical';

export interface SelectorItemProps
  extends Omit<SelectProps<string>, 'options' | 'children'> {
  label: string;
  helperText?: string;
  options: { key: string; value: string }[];
  uiMode: UiMode;
  marginLeft?: boolean;
  marginTop?: boolean;
  marginRight?: boolean;
  marginBottom?: boolean;
}

function getContainerClassName(mode: UiMode): string {
  switch (mode) {
    case 'horizontal':
      return 'selector-row-container';
    case 'vertical':
      return 'selector-column-container';
  }
}

function getLabelClassName(mode: UiMode): string {
  switch (mode) {
    case 'horizontal':
      return 'selector-label-row';
    case 'vertical':
      return 'selector-label-column';
  }
}

const SelectorItem: React.FunctionComponent<SelectorItemProps> = (
  props: SelectorItemProps
) => {
  const {
    label,
    helperText,
    options,
    uiMode,
    marginLeft,
    marginTop,
    marginRight,
    marginBottom,
    ...remains
  } = props;
  const marginStyle = {
    marginLeft: marginLeft ? '8px' : '0px',
    marginTop: marginTop ? '8px' : '0px',
    marginRight: marginRight ? '8px' : '0px',
    marginBottom: marginBottom ? '8px' : '0px',
  };

  return (
    <div className={getContainerClassName(uiMode)} style={marginStyle}>
      {props.helperText && (
        <Typography.Text className={getLabelClassName(uiMode)}>
          {helperText}
        </Typography.Text>
      )}
      <Select
        showSearch
        placeholder={label}
        className="selector-content"
        {...remains}
      >
        {options.map((item: { key: string; value: string }, index: number) => (
          <Select.Option key={index} value={item.key}>
            {item.value}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectorItem;
